import { connect } from 'react-redux';
import ComparePage from 'components/compare/index';
import { getDataByCountry, getCountryProfileReport, getAverages, resetReportData } from 'redux-modules/compare';
import { getCountries } from 'redux-modules/country-profiles';
import { getActiveYears } from 'redux-modules/data';
import { setModalContent } from 'redux-modules/modal';
import { getTotalAssetments } from 'selectors/common';
import { getCountriesData, getCountriesDetail, getFilteredCountries, getCountryReportsLoading } from 'selectors/compare';

const mapStateToProps = (state) => ({
  parsedCompareCountries: getCountriesDetail(state),
  data: getCountriesData(state),
  countries: getFilteredCountries(state),
  totalAssestments: getTotalAssetments(state),
  countriesReports: state.compare.countriesReports,
  averages: state.compare.averages,
  activeYears: state.data.activeYears,
  filters: state.compare.filters,
  loading: state.countryProfile.mapCountriesLoading,
  countriesReportsLoading: getCountryReportsLoading(state)
});

const mapDispatchToProps = (dispatch) => ({
  getCountryProfileReport: (iso, countrySector, countryNum, years) => (
    dispatch(getCountryProfileReport(iso, countrySector, countryNum, years))
  ),
  getDataByCountry: (iso) => dispatch(getDataByCountry(iso)),
  resetReportData: () => dispatch(resetReportData()),
  getCountries: () => dispatch(getCountries()),
  getActiveYears: () => dispatch(getActiveYears()),
  setModalContent: (content) => dispatch(setModalContent(content)),
  getAverages: () => dispatch(getAverages())
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparePage);



// WEBPACK FOOTER //
// ./app/containers/compare/index.js